import React, {useState, useRef} from "react";
import {toast} from "react-toastify";
import {motion, AnimatePresence} from "framer-motion";
import RewardsModal from "../components/RewardsModal";
import config from "../config";
import { allWinners } from "../data/winners";
// import {CampaignData} from "../types/types";
// import {useLocation} from "react-router-dom";

const ParticipantForm: React.FC = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [campaignName] = useState("promex35");
    const [billCode, setBillCode] = useState("");
    const [mode, setMode] = useState<"create" | "check">("create");
    const [showRules, setShowRules] = useState(false);
    const [showRewards, setShowRewards] = useState(false);
    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const [expandedWinners, setExpandedWinners] = useState<Set<number>>(new Set());
    const [searchTerm, setSearchTerm] = useState("");
    const isCampaignActive = false;
    const areRewardsWithdrawn = true;

    const toggleWinner = (index: number) => {
        setExpandedWinners(prev => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
                newSet.delete(index);
            } else {
                newSet.add(index);
            }
            return newSet;
        });
    };

    const winners = allWinners.filter(winner => {
        if (!searchTerm.trim()) return true;
        const search = searchTerm.toLowerCase();
        return winner.ime.toLowerCase().includes(search) ||
               winner.prezime.toLowerCase().includes(search);
    });

    const lastNameRef = useRef<HTMLInputElement>(null);
    const phoneRef = useRef<HTMLInputElement>(null);
    const codeRefs = useRef<(HTMLInputElement | null)[]>([]);

    // const location = useLocation();
    // const campaignData = location.state?.campaignData as CampaignData | undefined;

    const phonePattern = /^(?:\+381|06)\d{5,}$/;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!firstName.trim()) {
            toast.error("Niste uneli ime.", {position: "top-center"});
            return;
        }

        if (!lastName.trim()) {
            toast.error("Niste uneli prezime.", {position: "top-center"});
            return;
        }


        if (!phonePattern.test(phone.trim())) {
            toast.error("Broj telefona mora počinjati sa +381 ili 06.", {
                position: "top-center",
            });
            return;
        }

        const payload = {
            firstName,
            lastName,
            phoneNumber: phone,
            billCode: billCode,
            campaignName
        };

        try {
            const response = await fetch(
                `${config.BASE_URL}/public/campaigns/fea4a9c1-254f-42d3-bcab-2f884fc46139/participants/enroll`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.message || "Greška u slanju");
            }

            toast.success("Uspešno ste se prijavili!", {
                position: "top-center",
                autoClose: 3000,
            });
            setFirstName("");
            setLastName("");
            setPhone("");
            setBillCode("");
        } catch (err: any) {
            toast.error(err.message, {
                position: "top-center",
                autoClose: 5000,
            });

            console.error("Greška:", err.message);
        }
    };

    const handleValidateBill = async () => {
        const code = billCode;

        try {
            const response = await fetch(
                `${config.BASE_URL}/public/bill-code/${code}/check`,
                {
                    method: "GET",
                }
            );

            const data = await response.json();

            if (response.ok) {
                if (data.isUsed === false) {
                    toast.success(data.message, {position: "top-center"});
                    setFirstName("");
                    setLastName("");
                    setPhone("");
                    setMode("create");
                } else {
                    toast.error(data.message, {position: "top-center"});
                    setBillCode("");
                }
            } else {
                toast.error(data.message || "Nevažeći zahtev.", {
                    position: "top-center",
                });
            }
        } catch (err: any) {
            toast.error("Došlo je do greške pri proveri.", {
                position: "top-center",
            });
            console.error("Greška:", err.message);
        }
    };


    const formatBillCode = (input: string): string => {
        const raw = input.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

        const part1 = raw.substring(0, 8); // alphanumeric
        const part2 = raw.substring(8, 16); // alphanumeric
        const part3 = raw.substring(16, 100).replace(/\D/g, ""); // digits only

        const parts = [];
        if (part1) parts.push(part1);
        if (part2) parts.push(part2);
        if (part3) parts.push(part3);

        return parts.join("-");
    };

    return (
        <div className="bg-white min-h-screen flex flex-col justify-between">
            <div className=" w-full overflow-hidden absolute">
                <img
                    className="max-w-none lg:w-full -mt-24"
                    src="/assets/Bubbles.svg"
                    alt="baloncici"
                />
            </div>

            <div className="z-20">
                {/* HEADER */}

                <header className="w-full h-48 flex items-center justify-between px-3 lg:px-12">
                    {/* Levo */}
                    <div className="h-1/3 hidden lg:block flex justify-center">
                        <img
                            className="h-full object-cover block"
                            src="/assets/coffee-bean_icon.svg"
                            alt="coffee"
                        />
                    </div>

                    <motion.div
                        className="cursor-pointer px-3 -ml-12 lg:ml-0        -mt-20 lg:-mt-10 h-full flex justify-center
"
                        onClick={() => setShowRewards(true)}
                        whileTap={{y: 10}}
                        whileHover={{y: 6}}
                        transition={{type: "spring", stiffness: 400, damping: 10}}
                    >
                        <img
                            className="h-full object-cover"
                            src="/assets/gift-baner-2.svg"
                            alt="pokloni"
                        />
                    </motion.div>

                    <motion.div
                        className="cursor-pointer  px-3                      -mt-20 lg:-mt-10 h-full flex justify-center -ml-36 lg:ml-0"
                        onClick={() => setShowRules(true)}
                        whileTap={{y: 10}}
                        whileHover={{y: 6}}
                        transition={{type: "spring", stiffness: 400, damping: 10}}
                    >
                        <img
                            className="h-full object-cover"
                            src="/assets/rules-baner-2.svg"
                            alt="pokloni"
                        />
                    </motion.div>

                    {/* Desno */}
                    <div
                        className="h-full flex items-center "
                    >
                        <a
                            href="https://www.promeks.co.rs/o-nama"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                className=""
                                src="/assets/promeks_baner.png"
                                alt="promeks baner"
                            />
                        </a>
                    </div>
                </header>

                {/* FORMA */}
                <main className="flex flex-col items-center justify-center px-4 pt-8 mb-5 -mt-12 lg:-mt-24 ">
                    <AnimatePresence>
                        {showRules && (
                            <motion.div
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center px-4"
                            >
                                <motion.div
                                    initial={{scale: 0.8, opacity: 0}}
                                    animate={{scale: 1, opacity: 1}}
                                    exit={{scale: 0.8, opacity: 0}}
                                    transition={{duration: 0.3, ease: "easeOut"}}
                                    className="bg-white rounded-xl max-w-xl w-full p-6 relative shadow-xl"
                                >
                                    <button
                                        onClick={() => setShowRules(false)}
                                        className="absolute top-2 right-2 text-2xl font-bold text-gray-600 hover:text-black"
                                    >
                                        &times;
                                    </button>
                                    <h2 className="text-xl font-bold mb-4 text-center">
                                        PRAVILA POKLANJANJA
                                    </h2>

                                    <ul className="list-disc space-y-2 pl-5 text-sm text-gray-700 text-left">
                                        <li>
                                            <span className="font-semibold text-green-700">Rođendansko darivanje počinje:</span>{" "}
                                            <strong>01.06.2026.</strong> i završava se <strong>30.06.2026.</strong>
                                        </li>
                                        <li>
                                            Da biste učestvovali u darivanju potrebno je da posedujete fiskalni račun iz bilo kog Promeks maloprodajnog objekta na kome se nalazi{" "}
                                            <strong>najmanje 300 grama Promeksove kafe</strong>.
                                        </li>
                                        <li>
                                            Svako može učestvovati <strong>neograničen broj puta</strong>.
                                        </li>
                                        <li>
                                            Na pultovima u radnjama, posterima i društvenim mrežama nalazi se QR kod. Skenirajte ga ili jednostavno posetite{" "}
                                            <a
                                                href="https://rodjendan.promeks.rs"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="underline text-blue-600 font-semibold"
                                            >
                                                rođendan.promeks.rs
                                            </a>
                                            . Otvoriće vam se formular za prijavu. Popunite sva polja i kliknite na dugme{" "}
                                            <strong>„PRIJAVI ME"</strong> – time ste se uspješno prijavili.
                                        </li>
                                        <li className="font-semibold text-red-600">
                                            OBAVEZNO SAČUVAJTE FISKALNI RAČUN!
                                        </li>
                                        <li>
                                            <strong>Poslednji dan darivanja:</strong>{" "}
                                            <span className="text-green-700 font-semibold">30. jun 2026.</span>
                                            {" "}Tada izvlačimo pobednike, a spisak će biti objavljen na društvenim mrežama i u Glasu Podrinja.
                                        </li>
                                        <li className="font-semibold text-red-600">
                                            Za podizanje nagrade potrebno je doneti originalni fiskalni račun na uvid!
                                        </li>
                                        <li>
                                            <strong>Napomena:</strong> Datum računa mora biti u periodu trajanja darivanja – od{" "}
                                            <span className="text-green-700 font-semibold">01.06.2026. do 30.06.2026.</span>
                                        </li>
                                        <li>
                                            Na računu mora biti najmanje <strong>300 g Promeks kafe</strong>.
                                        </li>
                                    </ul>
                                </motion.div>
                            </motion.div>
                        )}
                    </AnimatePresence>

                    <div className="mb-4">
                        <img src="/assets/promeks_logo.png?v=2" alt="promeks logo" className="max-w-xs lg:max-w-sm mx-auto"/>
                    </div>

                    <div className="text-center max-w-xl text-base text-gray-700 mb-6 font-medium">
                        <h1 className="text-2xl lg:text-3xl font-bold text-green-800 leading-tight">
                            PROMEKS ROĐENDANSKO DARIVANJE
                        </h1>
                    </div>

                    {areRewardsWithdrawn ? (
                        <div className="rounded-xl bg-white border-2 border-green-700 max-w-6xl w-full p-4 lg:p-6 shadow-lg">
                            <h2 className="text-xl lg:text-2xl font-bold text-green-800 mb-4 lg:mb-6 text-center">
                                Čestitamo!
                            </h2>

                            <div className="mb-4">
                                <div className="relative max-w-md mx-auto">
                                    <input
                                        type="text"
                                        placeholder="Pretraži po imenu ili prezimenu..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="w-full px-4 py-2 pr-10 border-2 border-green-300 rounded-lg focus:outline-none focus:border-green-600 text-sm leading-normal"
                                    />
                                    {searchTerm ? (
                                        <button
                                            type="button"
                                            onClick={() => setSearchTerm("")}
                                            className="absolute inset-y-0 right-0 flex items-center justify-center w-10 text-gray-400 hover:text-gray-600"
                                            aria-label="Obriši pretragu"
                                        >
                                            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    ) : (
                                        <div className="absolute inset-y-0 right-0 flex items-center justify-center w-10 pointer-events-none text-gray-400">
                                            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                            </svg>
                                        </div>
                                    )}
                                </div>
                                {searchTerm && (
                                    <p className="text-center text-sm text-gray-600 mt-2">
                                        Pronađeno: {winners.length} {winners.length === 1 ? 'pobednik' : 'pobednika'}
                                    </p>
                                )}
                            </div>

                            <div className="block lg:hidden space-y-2">
                                {winners.length > 0 ? (
                                    winners.map((winner, index) => {
                                        const isExpanded = expandedWinners.has(index);
                                        return (
                                            <div key={index} className="border-2 border-green-300 rounded-lg bg-green-50 overflow-hidden">
                                                <div
                                                    className="grid grid-cols-2 gap-3 p-3 cursor-pointer active:bg-green-100 transition-colors"
                                                    onClick={() => toggleWinner(index)}
                                                >
                                                    <div>
                                                        <div className="text-xs text-gray-600 mb-1">Nagrada</div>
                                                        <div className="font-semibold text-green-800 text-sm">{winner.poklon}</div>
                                                    </div>
                                                    <div className="flex justify-between items-start">
                                                        <div>
                                                            <div className="text-xs text-gray-600 mb-1">Ime i Prezime</div>
                                                            <div className="font-semibold text-sm">{winner.ime} {winner.prezime}</div>
                                                        </div>
                                                        <div className="text-green-700 ml-2 mt-4">
                                                            {isExpanded ? (
                                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                                </svg>
                                                            ) : (
                                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                                </svg>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {isExpanded && (
                                                    <div className="px-3 pb-3 pt-0 border-t border-green-300 bg-white">
                                                        <div className="space-y-2 text-sm mt-3">
                                                            <div className="flex">
                                                                <span className="font-semibold text-gray-700 w-28">Nagrada:</span>
                                                                <span className="text-green-800">{winner.poklon}</span>
                                                            </div>
                                                            <div className="flex">
                                                                <span className="font-semibold text-gray-700 w-28">Ime i Prezime:</span>
                                                                <span>{winner.ime} {winner.prezime}</span>
                                                            </div>
                                                            <div className="flex">
                                                                <span className="font-semibold text-gray-700 w-28">Broj Računa:</span>
                                                                <span className="font-mono text-xs break-all">{winner.brojRacuna}</span>
                                                            </div>
                                                            <div className="flex">
                                                                <span className="font-semibold text-gray-700 w-28">Broj Telefona:</span>
                                                                <span className="font-mono">{winner.brojTelefona}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="text-center py-8 text-gray-500">
                                        {searchTerm ? 'Nije pronađen nijedan pobednik sa tim imenom ili prezimenom.' : 'Lista pobednika će uskoro biti objavljena'}
                                    </div>
                                )}
                            </div>

                            <div className="hidden lg:block overflow-x-auto">
                                <table className="w-full border-collapse text-sm">
                                    <thead>
                                        <tr className="bg-green-700 text-white">
                                            <th className="border border-green-800 px-3 py-2 text-left">Poklon</th>
                                            <th className="border border-green-800 px-3 py-2 text-left">Ime</th>
                                            <th className="border border-green-800 px-3 py-2 text-left">Prezime</th>
                                            <th className="border border-green-800 px-3 py-2 text-left">Broj Računa</th>
                                            <th className="border border-green-800 px-3 py-2 text-left">Broj Telefona</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {winners.length > 0 ? (
                                            winners.map((winner, index) => (
                                                <tr key={index} className={index % 2 === 0 ? "bg-green-50" : "bg-white"}>
                                                    <td className="border border-green-300 px-3 py-2">{winner.poklon}</td>
                                                    <td className="border border-green-300 px-3 py-2">{winner.ime}</td>
                                                    <td className="border border-green-300 px-3 py-2">{winner.prezime}</td>
                                                    <td className="border border-green-300 px-3 py-2 font-mono text-xs">{winner.brojRacuna}</td>
                                                    <td className="border border-green-300 px-3 py-2 font-mono">{winner.brojTelefona}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5} className="border border-green-300 px-4 py-8 text-center text-gray-500">
                                                    {searchTerm ? 'Nije pronađen nijedan pobednik sa tim imenom ili prezimenom.' : 'Lista pobednika će uskoro biti objavljena'}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : !isCampaignActive ? (
                        <div className="rounded-xl bg-green-50 border-2 border-green-700 max-w-md w-full p-8 text-center">
                            <h2 className="text-xl font-bold text-green-800 mb-3">
                                Poklanjanje je završeno
                            </h2>
                            <p className="text-gray-700 text-lg">
                                Uskoro ćemo objaviti rezultate.
                            </p>
                        </div>
                    ) : (
                        <form
                            onSubmit={handleSubmit}
                            className="rounded max-w-md w-full space-y-4"
                        >
                        {/* Polja za unos korisnika – prikazuju se samo u create modu */}
                        {mode === "create" && (
                            <>
                                <input
                                    className="w-full border p-2 rounded border-gray-600"
                                    placeholder="Ime*"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            lastNameRef.current?.focus();
                                        }
                                    }}
                                />

                                <input
                                    ref={lastNameRef}
                                    className="w-full border p-2 rounded border-gray-600"
                                    placeholder="Prezime*"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            phoneRef.current?.focus();
                                        }
                                    }}
                                />

                                <div className="w-full">
                                    <input
                                        type="tel"
                                        inputMode="tel"
                                        pattern="[0-9+]*"
                                        ref={phoneRef}
                                        className={`w-full p-2 rounded 
    ${isPhoneValid ? "border-green-600" : "border-red-600"} 
    border-2 transition-all duration-200`}
                                        placeholder="Broj telefona*"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        onBlur={() => {
                                            const isValid =
                                                phonePattern.test(phone.trim());
                                            setIsPhoneValid(isValid);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                codeRefs.current[0]?.focus();
                                            }
                                        }}
                                    />
                                    <p
                                        className={`text-sm pl-1 mt-1 ${isPhoneValid ? "text-gray-500" : "text-red-600"
                                        }`}
                                    >
                                        Broj telefona mora počinjati sa "+381" ili "06"
                                    </p>
                                </div>
                            </>
                        )}

                        <div className="w-full">
                            <input
                                type="text"
                                className="w-full border p-2 rounded border-gray-600 text-center tracking-widest uppercase"
                                placeholder="7AF4D923-E3B30A31-234"
                                value={billCode}
                                onChange={(e) => setBillCode(formatBillCode(e.target.value))}
                            />
                            <p className="text-sm text-gray-600 text-center mt-1">
                                Unesi kod sa fiskalnog računa
                            </p>
                        </div>

                        <hr className="my-4 border-t border-gray-300"/>

                        {/* Dugmad – različita po režimu */}
                        {mode === "create" ? (
                            <>
                                <button
                                    type="submit"
                                    className="w-full bg-green-700 text-white py-2 rounded-full hover:bg-green-900"
                                >
                                    Prijavi me
                                </button>

                                <button
                                    type="button"
                                    className="w-full bg-white text-black border border-black py-2 rounded-full hover:bg-black hover:text-white transition-colors"
                                    onClick={() => setMode("check")}
                                >
                                    Proverite kod računa
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    type="button"
                                    className="w-full bg-green-700 text-white py-2 rounded-full hover:bg-green-900"
                                    onClick={handleValidateBill}
                                >
                                    Proveri račun
                                </button>

                                <button
                                    type="button"
                                    className="w-full bg-white text-black border border-black py-2 rounded-full hover:bg-black hover:text-white transition-colors"
                                    onClick={() => setMode("create")}
                                >
                                    Nazad
                                </button>
                            </>
                        )}
                    </form>
                    )}

                    <RewardsModal
                        open={showRewards}
                        onClose={() => setShowRewards(false)}
                    />
                </main>
            </div>

            {/* FIXED BALONČIĆI NA DNU */}
            {/* BUBBLE FOOTER FIXED */}
            <div className=" -mt-5 lg:-mt-28 ">
                {/* <img className="max-w-none lg:w-full object-cover" src="/assets/Bubbles.svg" alt="baloncici" /> */}
                <img className="w-full" src="/assets/kafidzonka2.svg" alt="zrna kafe"/>
            </div>
        </div>
    );
};

export default ParticipantForm;
